import {
  INITIALISE_CAROUSEL,
  SET_INDEX_CAROUSEL,
  SET_TRANSITION_START_CAROUSEL,
  SET_TRANSITION_END_CAROUSEL,
  SET_NO_OF_PAGES_CAROUSEL,
} from './actions';

import {
  TRANSITION_STATUS_READY,
  TRANSITION_STATUS_PRE_TRANSITION,
  TRANSITION_STATUS_TRANSITIONING,
} from './transitionStatus';

const getCurrentItemIndex = ({ index, state }) => {
  const isForward = index > state.currentIndex;

  const currentItemIndex = isForward ? (
    state.currentItemIndex + state.noPerPage
  ) : (
    state.currentItemIndex - state.noPerPage
  );

  if (currentItemIndex >= state.noOfItems) {
    return currentItemIndex - state.noOfItems;
  }

  if (currentItemIndex <= 0) {
    return state.noOfItems + currentItemIndex;
  }

  return currentItemIndex;
};

const initialise = (state, {
  carouselsStoreDataKey,
  noOfItems,
  noPerPage = 1,
  infinite,
}) => ({
  ...state,
  [carouselsStoreDataKey]: {
    ...state[carouselsStoreDataKey],
    infinite,
    currentIndex: 0,
    previousIndex: 0,
    currentItemIndex: 0,
    previousItemIndex: 0,
    noOfItems,
    noOfPages: Math.ceil(noOfItems / noPerPage),
    noPerPage,
    transitionStatus: TRANSITION_STATUS_READY,
  },
});

const setIndex = (state, { carouselsStoreDataKey, index }) => {
  const existingState = state[carouselsStoreDataKey];

  const setNewIndex = (
    existingState &&
    index >= 0 &&
    index < existingState.noOfPages &&
    index !== existingState.currentIndex
  );

  const currentItemIndex = getCurrentItemIndex({ index, state: existingState });

  if (setNewIndex || existingState.infinite) {
    return {
      ...state,
      [carouselsStoreDataKey]: {
        ...existingState,
        currentIndex: index,
        currentItemIndex,
        previousItemIndex: existingState.currentItemIndex,
        previousIndex: existingState.currentIndex,
        transitionStatus: TRANSITION_STATUS_PRE_TRANSITION,
      },
    };
  }

  return state;
};

const setTransitionStart = (state, { carouselsStoreDataKey }) => ({
  ...state,
  [carouselsStoreDataKey]: {
    ...state[carouselsStoreDataKey],
    transitionStatus: TRANSITION_STATUS_TRANSITIONING,
  },
});

const setTransitionEnd = (state, { carouselsStoreDataKey }) => ({
  ...state,
  [carouselsStoreDataKey]: {
    ...state[carouselsStoreDataKey],
    transitionStatus: TRANSITION_STATUS_READY,
  },
});

const setNoOfPages = (state, { carouselsStoreDataKey, noOfItems, noPerPage = 1 }) => {
  const { currentIndex, ...existingState } = state[carouselsStoreDataKey];
  const noOfPages = Math.ceil(noOfItems / noPerPage);

  if (noOfPages === existingState.noOfPages) {
    return state;
  }

  return {
    ...state,
    [carouselsStoreDataKey]: {
      ...existingState,
      noOfItems,
      noOfPages,
      noPerPage,
      currentIndex: currentIndex < noOfPages ? currentIndex : noOfPages - 1,
    },
  };
};

const reducer = {
  [INITIALISE_CAROUSEL]: initialise,
  [SET_INDEX_CAROUSEL]: setIndex,
  [SET_TRANSITION_START_CAROUSEL]: setTransitionStart,
  [SET_TRANSITION_END_CAROUSEL]: setTransitionEnd,
  [SET_NO_OF_PAGES_CAROUSEL]: setNoOfPages,
};

export default (state = {}, action) => (
  action.type && reducer[action.type] ? reducer[action.type](state, action) : state
);
